/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as authorizationV1 from "./keyapis_identity_authorization_v1.pb"

/**
 * Сервис предоставляет возможность авторизации
 */

/**
 * Сервис авторизации пользователей по процедуре OAuth2
 */
export class Oauth2ServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод авторизации по ОТП-коду по процедуре OAuth2.
   * Метод возвращает переадресацию в виде GRPC метаданных x-http-code и location.
   * Не требует авторизации
   */
  PostOauth2LoginByCode = (req: PostOauth2LoginByCodeRequestDto, init?: RequestInit): Promise<PostOauth2LoginByCodeResponseDto> => {
    return fm.request<PostOauth2LoginByCodeRequestDto, PostOauth2LoginByCodeResponseDto>(`${this.host}/identity/api/v1/oauth2/login_by_code`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод авторизации по паролю по процедуре OAuth2.
   * Метод возвращает переадресацию в виде GRPC метаданных x-http-code и location.
   * Не требует авторизации
   */
  PostOauth2LoginByPassword = (req: PostOauth2LoginByPasswordRequestDto, init?: RequestInit): Promise<PostOauth2LoginByPasswordResponseDto> => {
    return fm.request<PostOauth2LoginByPasswordRequestDto, PostOauth2LoginByPasswordResponseDto>(`${this.host}/identity/api/v1/oauth2/login_by_password`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод запроса соглашения пользователя по процедуре OAuth2.
   * Метод возвращает переадресацию в виде GRPC метаданных x-http-code и location.
   * Не требует авторизации
   */
  GetOauth2Consent = (req: GetOauth2ConsentRequestDto, init?: RequestInit): Promise<GetOauth2ConsentResponseDto> => {
    return fm.request<GetOauth2ConsentRequestDto, GetOauth2ConsentResponseDto>(`${this.host}/identity/api/v1/oauth2/consent${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Ошибки авторизационного сервиса
 */
export type AuthServiceErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибки авторизационного сервиса
   */
  readonly auth: AuthServiceErrorAuthErrorRequestDto
}>
/**
 * Ошибки авторизационного сервиса
 */
export type AuthServiceErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибки авторизационного сервиса
   */
  readonly auth: AuthServiceErrorAuthErrorResponseDto
}>
/**
 * Ошибки авторизационного сервиса
 */
export type AuthServiceErrorAuthErrorRequestDto = {
}
/**
 * Ошибки авторизационного сервиса
 */
export type AuthServiceErrorAuthErrorResponseDto = {
}
/**
 * Запрос соглашения пользователя по процедуре OAuth2
 */
export type GetOauth2ConsentRequestDto = {
  /**
   * Идентификатор текущей попытки запроса соглашения пользователя
   */
  consentChallenge: string
}
/**
 * Ответ на запрос соглашения пользователя по процедуре OAuth2
 */
export type GetOauth2ConsentResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetOauth2ConsentResponseErrorDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type GetOauth2ConsentResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorRequestDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type GetOauth2ConsentResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorResponseDto
}>
/**
 * Запрос на авторизацию по ОТП-коду
 */
export type PostOauth2LoginByCodeRequestDto = {
  /**
   * Идентификатор ОТП-кода
   */
  codeId: string
  /**
   * Значение ОТП-кода
   */
  code: string
  /**
   * Идентификатор текущей попытки логина пользователя
   */
  loginChallenge: string
}
/**
 * Ответ на запрос об авторизации пользователя
 */
export type PostOauth2LoginByCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostOauth2LoginByCodeResponseErrorDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostOauth2LoginByCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка отп-кода
   */
  readonly otpCode: authorizationV1.OtpCodeErrorRequestDto
  /**
   * Ошибка из ССО
   */
  readonly sso: authorizationV1.SsoErrorRequestDto
  /**
   * Ошибки сервисов ключа
   */
  readonly key: authorizationV1.KeyErrorRequestDto
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorRequestDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostOauth2LoginByCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка отп-кода
   */
  readonly otpCode: authorizationV1.OtpCodeErrorResponseDto
  /**
   * Ошибка из ССО
   */
  readonly sso: authorizationV1.SsoErrorResponseDto
  /**
   * Ошибки сервисов ключа
   */
  readonly key: authorizationV1.KeyErrorResponseDto
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorResponseDto
}>
/**
 * Запрос на авторизацию по паролю
 */
export type PostOauth2LoginByPasswordRequestDto = {
  /**
   * Пароль
   */
  password: string
  /**
   * Ответ на капчу
   */
  captchaAnswer?: authorizationV1.CaptchaAnswerRequestDto | null
  /**
   * Идентификатор текущей попытки логина пользователя
   */
  loginChallenge: string
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Номер телефона
   */
  readonly phoneNumber: string
  /**
   * Электронная почта
   */
  readonly email: string
  /**
   * Логин
   */
  readonly login: string
}>
/**
 * Ответ на запрос об авторизации по паролю пользователя
 */
export type PostOauth2LoginByPasswordResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostOauth2LoginByPasswordResponseErrorDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostOauth2LoginByPasswordResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка капчи
   */
  readonly captchaAnswer: authorizationV1.CaptchaAnswerErrorRequestDto
  /**
   * Ошибка из ССО
   */
  readonly sso: authorizationV1.SsoErrorRequestDto
  /**
   * Ошибки сервисов ключа
   */
  readonly key: authorizationV1.KeyErrorRequestDto
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorRequestDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostOauth2LoginByPasswordResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка капчи
   */
  readonly captchaAnswer: authorizationV1.CaptchaAnswerErrorResponseDto
  /**
   * Ошибка из ССО
   */
  readonly sso: authorizationV1.SsoErrorResponseDto
  /**
   * Ошибки сервисов ключа
   */
  readonly key: authorizationV1.KeyErrorResponseDto
  /**
   * Ошибки авторизационного сервиса
   */
  readonly authService: AuthServiceErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Ошибки авторизационного сервиса
   */
  "AuthServiceError": {
    "kind": "class",
    "text": "Ошибки авторизационного сервиса",
    "fields": {
      /**
       * Ошибки авторизационного сервиса
       */
      "auth": {
        "type": "AuthServiceError.AuthError",
        "text": "Ошибки авторизационного сервиса",
      },
    },
  },
  /**
   * Ошибки авторизационного сервиса
   */
  "AuthServiceError.AuthError": {
    "kind": "class",
    "text": "Ошибки авторизационного сервиса",
  },
  /**
   * Запрос соглашения пользователя по процедуре OAuth2
   */
  "GetOauth2ConsentRequest": {
    "kind": "class",
    "text": "Запрос соглашения пользователя по процедуре OAuth2",
    "fields": {
      /**
       * Идентификатор текущей попытки запроса соглашения пользователя
       */
      "consentChallenge": {
        "type": "string",
        "text": "Идентификатор текущей попытки запроса соглашения пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос соглашения пользователя по процедуре OAuth2
   */
  "GetOauth2ConsentResponse": {
    "kind": "class",
    "text": "Ответ на запрос соглашения пользователя по процедуре OAuth2",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOauth2ConsentResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса авторизации пользователя
   */
  "GetOauth2ConsentResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса авторизации пользователя",
    "fields": {
      /**
       * Ошибки авторизационного сервиса
       */
      "authService": {
        "type": "AuthServiceError",
        "text": "Ошибки авторизационного сервиса",
      },
    },
  },
  /**
   * Запрос на авторизацию по ОТП-коду
   */
  "PostOauth2LoginByCodeRequest": {
    "kind": "class",
    "text": "Запрос на авторизацию по ОТП-коду",
    "fields": {
      /**
       * Идентификатор ОТП-кода
       */
      "codeId": {
        "type": "string",
        "text": "Идентификатор ОТП-кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ОТП-кода
       */
      "code": {
        "type": "string",
        "text": "Значение ОТП-кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор текущей попытки логина пользователя
       */
      "loginChallenge": {
        "type": "string",
        "text": "Идентификатор текущей попытки логина пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос об авторизации пользователя
   */
  "PostOauth2LoginByCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос об авторизации пользователя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostOauth2LoginByCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса авторизации пользователя
   */
  "PostOauth2LoginByCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса авторизации пользователя",
    "fields": {
      /**
       * Ошибка отп-кода
       */
      "otpCode": {
        "type": "OtpCode.Error",
        "text": "Ошибка отп-кода",
      },
      /**
       * Ошибка из ССО
       */
      "sso": {
        "type": "SsoError",
        "text": "Ошибка из ССО",
      },
      /**
       * Ошибки сервисов ключа
       */
      "key": {
        "type": "KeyError",
        "text": "Ошибки сервисов ключа",
      },
      /**
       * Ошибки авторизационного сервиса
       */
      "authService": {
        "type": "AuthServiceError",
        "text": "Ошибки авторизационного сервиса",
      },
    },
  },
  /**
   * Запрос на авторизацию по паролю
   */
  "PostOauth2LoginByPasswordRequest": {
    "kind": "class",
    "text": "Запрос на авторизацию по паролю",
    "fields": {
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "string",
        "text": "Номер телефона",
      },
      /**
       * Электронная почта
       */
      "email": {
        "type": "string",
        "text": "Электронная почта",
      },
      /**
       * Логин
       */
      "login": {
        "type": "string",
        "text": "Логин",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ответ на капчу
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer",
        "text": "Ответ на капчу",
      },
      /**
       * Идентификатор текущей попытки логина пользователя
       */
      "loginChallenge": {
        "type": "string",
        "text": "Идентификатор текущей попытки логина пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос об авторизации по паролю пользователя
   */
  "PostOauth2LoginByPasswordResponse": {
    "kind": "class",
    "text": "Ответ на запрос об авторизации по паролю пользователя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostOauth2LoginByPasswordResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса авторизации пользователя
   */
  "PostOauth2LoginByPasswordResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса авторизации пользователя",
    "fields": {
      /**
       * Ошибка капчи
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer.Error",
        "text": "Ошибка капчи",
      },
      /**
       * Ошибка из ССО
       */
      "sso": {
        "type": "SsoError",
        "text": "Ошибка из ССО",
      },
      /**
       * Ошибки сервисов ключа
       */
      "key": {
        "type": "KeyError",
        "text": "Ошибки сервисов ключа",
      },
      /**
       * Ошибки авторизационного сервиса
       */
      "authService": {
        "type": "AuthServiceError",
        "text": "Ошибки авторизационного сервиса",
      },
    },
  },
}